import React, {
  ReactElement, useCallback, useState,
} from 'react';
import {
  Button, Input, Table, Tbody, Td, Text, Th, Thead, Tr,
} from 'idsk-react-components';
import './sprievodnyDokumentZmenaPoradiaListTable.scss';
import sortIcon from '../../../../../assets/images/icon-sort-documents-blue.svg';
import SprievodnyDokument from '../../../../model/legislativnyMaterial/SprievodnyDokument';

interface Props {
  sprievodnyDokumentList: Array<SprievodnyDokument>;
  setUpdatedList: (updatedData: SprievodnyDokument[]) => void;
}

const SprievodnyDokumentZmenaPoradiaListTable = ({
  sprievodnyDokumentList,
  setUpdatedList,
}: Props): ReactElement => {
  const [currentlyEditedIndex, setCurrentlyEditedIndex] = useState(null);
  const [currentlyEditedValue, setCurrentlyEditedValue] = useState<number>(null);
  const rowValues = Array.from({ length: sprievodnyDokumentList?.length }, (_, index) => index + 1);

  const changeOrderOfRow = (e: React.FormEvent<HTMLButtonElement>, index: number): void => {
    e.preventDefault();
    setCurrentlyEditedIndex(index);
    setCurrentlyEditedValue(rowValues[index]);
  };

  const handleRowValueChange = (newValue: number): void => {
    setCurrentlyEditedValue(newValue);
  };
  const handleSaveChanges = useCallback((e): void => {
    e.preventDefault();
    let newIndexNumber = currentlyEditedValue - 1;
    if (newIndexNumber < 1) {
      newIndexNumber = 0;
    }

    const newEditedSprievodnyDokumentList = sprievodnyDokumentList;
    const [movedItem] = newEditedSprievodnyDokumentList.splice(currentlyEditedIndex, 1);
    newEditedSprievodnyDokumentList.splice(newIndexNumber, 0, movedItem);
    newEditedSprievodnyDokumentList.forEach((item, i) => {
      // eslint-disable-next-line no-param-reassign
      item.index = i;
    });

    setUpdatedList(newEditedSprievodnyDokumentList);
    setCurrentlyEditedIndex(null);
    setCurrentlyEditedValue(null);
  }, [currentlyEditedIndex, currentlyEditedValue, setUpdatedList, sprievodnyDokumentList]);

  if (sprievodnyDokumentList?.length === 0) {
    return <Text type="p" size="l" className="text-center">Nenašli sa žiadne záznamy.</Text>;
  }

  return (
    <form onSubmit={handleSaveChanges}>
      <div className="sprievodny-dokument-list__table">
        <Table>
          <Thead>
            <Tr>
              <Th width="10%" className="col-1">
                Poradie
              </Th>
              <Th width="30%" className="col-2">
                Názov
              </Th>
              <Th width="40%" className="col-3">
                Typ dokumentu
              </Th>
              <Th width="20%" className="col-4" />
            </Tr>
          </Thead>
          <Tbody>
            {sprievodnyDokumentList?.map((dokument, index) => (
              <Tr key={dokument.uuid}>
                <Td className="col-1">
                  {currentlyEditedIndex === index ? (
                    <Input
                      required
                      title=""
                      max={Number.MAX_VALUE}
                      type="number"
                      value={currentlyEditedIndex === index ? currentlyEditedValue : rowValues[index]}
                      onChange={(e: {
                        target: { value: number; };
                      }) => handleRowValueChange(e.target.value)}
                      onInvalid={F => F.target.setCustomValidity('Prosím, zadajte kladnú číslicu poradia.')}
                      onInput={F => F.target.setCustomValidity('')}
                    />
                  ) : (
                    <>
                      {dokument.index + 1}
                    </>
                  )}
                </Td>
                <Td className="col-2">{dokument.nazov}</Td>
                <Td className="col-3">{dokument.typ?.nazov}</Td>
                <Td className="col-4">
                  {currentlyEditedIndex === index ? (
                    <Button
                      type="submit"
                      buttonStyle="link"
                      size="small"
                    >
                      Potvrdiť
                    </Button>
                  ) : (
                    <Button
                      type="button"
                      buttonStyle="link"
                      size="small"
                      iconBefore={sortIcon}
                      onClick={(e) => {
                        changeOrderOfRow(e, index);
                      }}
                    >
                      Zmeniť poradie
                    </Button>
                  )}
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </div>
    </form>
  );
};

export default SprievodnyDokumentZmenaPoradiaListTable;
